






























































































































































































































































































































































































import {Vue, Component} from 'vue-property-decorator'
import GenericToggleButton from '@/components/misc/GenericToggleButton.vue'
import {InputText} from '@simpli/vue-input'
import {$} from '@/facade'
import {OrbitProject} from '@/model/resource/OrbitProject'
import {ContractCollection} from '@/model/collection/ContractCollection'
import {OrbitNetworkHelper} from '@/helpers/OrbitNetworkHelper'
import {Contract} from '@/model/resource/Contract'
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue'
import {BlockchainVersion} from '@/model/resource/BlockchainVersion'
import {BlockchainVersionCollection} from '@/model/collection/BlockchainVersionCollection'
import {TokenPriced} from '@/model/resource/TokenPriced'
import {TokenPricedCollection} from '@/model/collection/TokenPricedCollection'
import OrbitAmountInput from '@/components/orbit/OrbitAmountInput.vue'

@Component({
  components: {
    OrbitAmountInput,
    GenericToggleButton,
    InputText,
    VueMultiselect,
  },
  computed: {
    $() {
      return $
    },
  },
})
export default class OrbitAddProjectFormStep extends Vue {
  blockchainVersionCollection = new BlockchainVersionCollection()
  contractCollection = new ContractCollection()
  tokenPricedCollection = new TokenPricedCollection()

  contractOptions: Contract[] = []
  tokenPricedOption: TokenPriced[] = []

  selectedAmount: string | null = null
  selectedBlockchain: BlockchainVersion | null = null
  selectedContract: Contract | null = null
  selectedTokenPriced: TokenPriced | null = null
  eventNames: string | null = null

  get isReviewStepAllowed() {
    return (
      this.selectedContract !== null &&
      this.selectedTokenPriced !== null &&
      this.selectedAmount !== null &&
      this.selectedBlockchain !== null
    )
  }

  mounted() {
    this.populateInitialResources()
  }

  async populateInitialResources() {
    const promises: Array<Promise<any>> = [
      this.blockchainVersionCollection.expand(),
    ]

    await this.$await.run('populateInitialResources', () =>
      Promise.all(promises)
    )
  }

  async handleChangeSelectedBlockchainInput(val: BlockchainVersion) {
    this.selectedBlockchain = val

    await this.populateFinalResources()
  }

  async populateFinalResources() {
    this.contractOptions = []
    this.tokenPricedOption = []

    const network = this.selectedBlockchain?.networkIdentifier

    if (!network) return

    await this.$await.run('populateFinalResources', async () => {
      const [contracts, tokens] = await Promise.all([
        OrbitNetworkHelper.contractOptionsOf(network),
        OrbitNetworkHelper.paymentTokenOptionsOf(network),
      ])

      this.contractOptions = contracts
      this.tokenPricedOption = tokens
    })
  }

  handleChangeSelectedContractInput(val: Contract) {
    this.selectedContract = val
  }

  handleChangeSelectedTokenPricedInput(val: TokenPriced) {
    this.selectedTokenPriced = val
  }

  handleInputAmount(val: string) {
    this.selectedAmount = val
  }

  clearFields() {
    this.selectedAmount = null
    this.selectedBlockchain = null
    this.selectedContract = null
    this.selectedTokenPriced = null
    this.eventNames = null
  }

  goToNextStep() {
    const orbitProject = new OrbitProject()

    const formattedAmount =
      (Number(this.selectedAmount) ?? 0) *
      10 ** (this.selectedTokenPriced?.decimals ?? 0)

    orbitProject.blockchainVersion = this.selectedBlockchain
    orbitProject.contract = this.selectedContract
    orbitProject.tokenPriced = this.selectedTokenPriced
    orbitProject.amount = formattedAmount
    orbitProject.assetType = '17'
    orbitProject.creatorAddress = $.walletAdapter.n3Address
    orbitProject.isFunded = false
    orbitProject.eventNames = this.eventNames?.trim() || null
    orbitProject.createdAt = new Date()

    this.$emit('next-step', orbitProject)
  }

  copyToClipboard(address: string) {
    this.$utils.copyToClipboard(address)
    this.$toast.info('system.info.copiedToClipboard')
  }

  closeModal() {
    this.clearFields()
    this.$emit('close')
  }
}
